export enum EducationLevel {
  ANY = 'Весь период',
  NOO = 'НОО',
  OOO = 'ООО',
  COO = 'СОО',
}
